import { PropsWithChildren } from "react";
import NavMenu from "./NavMenu";
import Header from "./Header";
import { CircularProgress, useTheme } from "@mui/joy";
import React from "react";
import { Util } from "./Helpers/Util";
import { RoleProvider, useRole } from "./Contexts/RoleContext";

interface LayoutProps {}

/**
 * Inner layout component that consumes the role context
 */
function LayoutInner(props: PropsWithChildren<LayoutProps>) {
	const theme = useTheme();
	const [loading, setLoading] = React.useState(true);
	const { setActualRole } = useRole();

	React.useEffect(() => {
		fetch("/User/GetPersonInfo", {
			method: "Post",
			cache: "no-cache",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({}),
		})
			.then((x) => x.json())
			.then((y) => {
				setLoading(false);
				Util.CurrentRole = y.role;
				setActualRole(y.role);
			});
	}, []);

	return loading ? <CircularProgress /> : (
		<div style={{ display: "flex", height: "100%", overflowY: "hidden" }}>
			<NavMenu />
			<div style={{ flex: 1, overflowY: "auto", height: "100%", display: "flex", flexDirection: "column", padding: theme.spacing(1) }}>
				<Header />
				{props.children}
			</div>
		</div>
	);
}

/**
 * Main layout component that provides the role context
 */
export default function Layout(props: PropsWithChildren<LayoutProps>) {
	return (
		<RoleProvider>
			<LayoutInner {...props} />
		</RoleProvider>
	);
}
